<template>
  <div class="material-info">
    <MaterialHeader />
    <div class="content-wrapper">
      <div class="content-title">
        {{ type === "create" ? "新建" : "编辑" }}物料
      </div>
      <div class="content-box">
        <div class="content-box__row">
          <el-form
            ref="materialForm"
            :rules="materialRules"
            label-position="right"
            :model="materialForm"
            label-width="120px"
            label-suffix="："
          >
            <el-form-item label="物料编码" prop="itemCode">
              <div v-if="type === 'edit' && materialForm.itemCode">
                {{ materialForm.itemCode }}
              </div>
              <el-input
                v-else
                v-model="materialForm.itemCode"
                placeholder="请输入物料编码"
              ></el-input>
            </el-form-item>
            <el-form-item label="物料类别" prop="itemTypeList">
              <el-checkbox-group v-model="materialForm.itemTypeList">
                <el-checkbox
                  v-for="(item, index) in itemTypes"
                  :key="index"
                  :label="item.itemTypeId"
                  >{{ item.typeName || "" }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="适用项目" prop="programTypeList">
              <el-checkbox-group v-model="materialForm.programTypeList">
                <el-checkbox
                  v-for="(item, index) in programTypes"
                  :key="index"
                  :label="item.programTypeId"
                  >{{ item.typeName || "" }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="物料名称" prop="itemName">
              <el-input
                v-model="materialForm.itemName"
                placeholder="请输入物料名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="应用范围" prop="appliedRange">
              <el-input
                type="textarea"
                v-model="materialForm.appliedRange"
                placeholder="请输入应用范围"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="itemUnit">
              <el-select
                v-model="materialForm.itemUnit"
                placeholder="请选择单位"
              >
                <el-option
                  v-for="(item, index) in tradeItemUnitMap"
                  :key="index"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="计价方式" prop="calculationRules">
              <el-select
                v-model="materialForm.calculationRules"
                placeholder="请选择计价方式"
              >
                <el-option
                  v-for="(item, index) in calculationRulesMap"
                  :key="index"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="质保期" prop="underWarranty">
              <el-input
                v-model="materialForm.underWarranty"
                placeholder="请输入质保期"
              ></el-input>
            </el-form-item>
            <el-form-item label="规格">
              <el-input
                v-model="materialForm.itemSpec"
                placeholder="请输入规格"
              ></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="itemDesc">
              <el-input
                type="textarea"
                v-model="materialForm.itemDesc"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="请输入描述"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="itemRemark">
              <el-input
                type="textarea"
                v-model="materialForm.itemRemark"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <el-button @click="handleBtn('cancel')">取消</el-button>
          <el-button type="primary" @click="handleBtn('save')">保存</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div class="hint">
        {{ messageDialog }}
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bccApi from '@/api/bcc'
import { mapState } from 'vuex'
import MaterialHeader from './components/material-header'
export default {
  name: 'material-info',
  components: {
    MaterialHeader
  },
  data () {
    return {
      dialogVisible: false,
      materialRules: {
        itemCode: [
          { required: true, message: '请输入物料编码', trigger: 'blur' },
          {
            validator: this.checkTradeItemCode,
            trigger: 'blur'
          }
        ],
        itemTypeList: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个物料类别',
            trigger: 'change'
          }
        ],
        programTypeList: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个活动项目',
            trigger: 'change'
          }
        ],
        itemName: [
          { required: true, message: '请输入物料名称', trigger: 'blur' }
        ],
        itemUnit: [
          { required: true, message: '请选择单位', trigger: 'change' }
        ],
        calculationRules: [
          { required: true, message: '请选择计价方式', trigger: 'change' }
        ],
        underWarranty: [
          { required: true, message: '请输入质保期', trigger: 'blur' }
        ],
        itemSpec: [{ required: true, message: '请输入规格', trigger: 'blur' }]
      },
      materialForm: {
        itemCode: '',
        itemTypeList: [],
        programTypeList: [],
        itemName: '',
        appliedRange: '',
        itemUnit: '',
        calculationRules: '',
        underWarranty: '',
        itemSpec: '',
        itemDesc: '',
        itemRemark: ''
      },
      operatingBtnType: '',
      itemTypes: [],
      programTypes: []
    }
  },
  computed: {
    ...mapState({
      tradeItemUnitMap: (state) => state.base.tradeItemUnitMap,
      calculationRulesMap: (state) =>
        state.base.tradeItemQuoteCalculationRulesMap
    }),
    type () {
      return this.$route.query.type
    },
    messageDialog () {
      return this.operatingBtnType === 'save'
        ? `是否确定${this.type === 'edit' ? '更改' : '保存'}物料信息？`
        : '您还有信息未保存，是否取消？'
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const type = this.$route.query.type
      this.getTradeItemtypes()
      this.getTradeItemProgramTypes()
      this.$store.dispatch(
        'getDictByName',
        'tradeItemQuoteCalculationRulesMap'
      )
      this.$store.dispatch('getDictByName', 'tradeItemUnitMap').then(() => {
        if (type === 'edit') {
          const itemCode = this.$route.query.itemCode
          this.getMaterialInfo(itemCode)
        }
      })
    },

    // 获取物料信息
    async getMaterialInfo (itemCode) {
      const { data } = await bccApi.getTradeItemInfo(itemCode)
      if (data.resultCode === '0') {
        const obj = data.resultData?.tradeItemInfo || {}
        const { itemTypeList = [], programTypeList = [] } = obj
        obj.itemTypeList = itemTypeList.map((item) => item.itemTypeId)
        obj.programTypeList = programTypeList.map((item) => item.programTypeId)
        this.materialForm = { ...obj }
        this.materialForm.itemUnit =
          this.tradeItemUnitMap.find((item) => item.value === obj.itemUnit)
            ?.key || ''
      }
    },

    // 查询物料类别
    async getTradeItemtypes () {
      const { data } = await bccApi.getTradeItemtypes()
      if (data.resultCode === '0') {
        this.itemTypes = data.resultData.itemTypes || []
      }
    },

    // 查询适用项目
    async getTradeItemProgramTypes () {
      const { data } = await bccApi.getTradeItemProgramTypes()
      if (data.resultCode === '0') {
        this.programTypes = data.resultData.programTypes || []
      }
    },

    // 取消 保存
    handleBtn (val) {
      if (val === 'cancel') {
        this.operatingBtnType = val
        this.dialogVisible = true
        return
      }

      // 保存校验
      this.$refs.materialForm.validate((valid) => {
        if (valid) {
          this.operatingBtnType = val
          this.dialogVisible = true
        } else {
          setTimeout(() => {
            var isError = document.getElementsByClassName('is-error')
            isError[0].querySelector('input').focus()
            let message = isError[0].querySelector('input').placeholder
            if (!message) {
              if (!this.materialForm.itemTypeList.length) {
                message = '请选择物料类别'
              } else if (!this.materialForm.programTypeList.length) {
                message = '请选择适用项目'
              }
            }
            this.$message.error(message)
          }, 100)
        }
      })
    },

    // 弹框确认
    handleConfirm () {
      if (this.operatingBtnType === 'cancel') {
        this.$router.back()
        return
      }
      this.saveMaterial()
    },

    // 验证编码是否存在
    async checkTradeItemCode (rule, value, callback) {
      if (this.type === 'edit') callback()
      const { data } = await bccApi.checkTradeItemCode(value)
      if (data.resultCode === '0') {
        const { itemCode = false } = data.resultData?.itemInfo || {}
        if (!itemCode) {
          callback()
        } else {
          callback(new Error('物料编号重复，请重新输入'))
        }
      }
      callback(new Error(data.resultMsg))
    },

    async saveMaterial () {
      const from = Object.assign({}, this.materialForm)
      from.itemTypeList = this.itemTypes.filter((item) =>
        this.materialForm.itemTypeList.includes(item.itemTypeId)
      )
      from.programTypeList = this.programTypes.filter((item) =>
        this.materialForm.programTypeList.includes(item.programTypeId)
      )
      from.itemUnit =
        this.tradeItemUnitMap.find(
          (item) => item.key === this.materialForm.itemUnit
        )?.value || ''

      let api = this.type === 'create' ? 'saveTradeItem' : 'updateTradeItem'
      let message = this.type === 'create' ? '保存' : '更改'

      const { data } = await bccApi[api](from)
      this.dialogVisible = false
      if (data.resultCode === '0') {
        this.$message.success(`${message}成功`)
        this.$router.replace({
          path: '/bcc/material/list'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 15px;
}
.content-box {
  border-radius: 10px;
  background-color: #fff;
  padding: 20px;
}
</style>
<style lang="scss">
.material-info {
  .el-input {
    width: 220px;
  }
  .el-textarea {
    width: 600px;
    & > textarea {
      resize: none;
    }
  }
  .el-form-item.is-error .el-input__inner {
    border-color: $base-red;
  }
  .el-form-item__error {
    color: $base-red;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
  }
  .el-checkbox__inner:hover,
  .el-checkbox__input .el-checkbox__inner:focus {
    border-color: #409eff !important;
  }
  .footer {
    width: 300px;
    margin: 40px auto;
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__header,
  .el-dialog__footer {
    border: 0;
    .el-button {
      width: 70px;
    }
  }
  .hint {
    text-align: center;
    font-size: $font-16;
  }
  .el-checkbox {
    min-width: 230px;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #a19d9d !important;
  }
}
</style>
